import { FC } from "react";
import { useTranslation } from "react-i18next";
import SelectBox from "@/components/atomic/SelectBox";
import { CategoryHeaderProps } from "./types";

export const CategoryHeader: FC<CategoryHeaderProps> = ({
  isMainPanel,
  selectedAnalysisId,
  selectedCategoryPath,
  analysisSelectOptions,
  onAnalysisChange,
  onOpenCategorySelect,
}) => {
  const { t } = useTranslation("voiceek_ui");

  return (
    <div
      className={`h-[124px] ${
        isMainPanel
          ? "[background:linear-gradient(180deg,rgb(84.39,104.98,159.54)_0%,rgb(41,61,114)_100%)]"
          : "[background:linear-gradient(180deg,#A5A5A5_0%,#626262_100%)]"
      } flex flex-col`}
    >
      <div className="mt-5 ml-[27px] [font-family:'Inter-Bold',Helvetica] font-bold text-white text-lg tracking-[0] leading-[normal]">
        {t("analysis.categorySummary.selectTarget")}
      </div>

      <div className="flex gap-3 mt-5 mx-5">
        <SelectBox
          className="w-[240px]"
          placeholder={t("analysis.categorySummary.selectTargetMonth")}
          options={analysisSelectOptions}
          currentValue={selectedAnalysisId}
          onValueChange={onAnalysisChange}
        />

        <button
          className="flex-1 w-full text-left h-[42px] px-5 py-2.5 rounded-[10px] border border-[#b6b6b6] bg-white disabled:cursor-not-allowed disabled:bg-gray-300 disabled:text-gray-600 truncate"
          onClick={onOpenCategorySelect}
          disabled={!selectedAnalysisId}
          title={selectedCategoryPath || t("analysis.categorySummary.selectCategory")}
        >
          {selectedCategoryPath || t("analysis.categorySummary.selectCategory")}
        </button>
      </div>
    </div>
  );
};
